import React from 'react';
import { Div } from '@dnb/eufemia';
import { Section } from '@dnb/eufemia/components';
import classnames from 'classnames';
import styles from './OverlappingHeaderContent.module.scss';

interface Props {
  narrow: boolean;
  children: React.ReactNode;
}

const OverlappingHeaderContent = ({ narrow, children }: Props) => {
  const classname = classnames(styles.container, {
    [styles.narrow]: narrow,
  });

  return (
    <Section
      data-testid="overlapping-header-content"
      className={styles.contentTop}
      style_type="white"
    >
      <Div
        data-testid={`container-${narrow ? 'narrow' : 'wide'}`}
        className={classname}
      >
        {children}
      </Div>
    </Section>
  );
};

export default OverlappingHeaderContent;
